var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "cog-checkable cog-input",
      class: [
        _vm.allowOther && "cog-checkable--allow-other",
        _vm.hasColumns ? _vm.columnClasses : "cog-checkable--inline",
        _vm.readonly && "is-read-only",
        _vm.isCard && "cog-checkable--card",
        _vm.isCard &&
          "cog-checkable--label-on-" +
            (!_vm.hasAtLeastOneImage || _vm.hideChoiceLabels
              ? "bottom"
              : _vm.cardLabelPosition),
        _vm.hasAtLeastOneImage && _vm.choiceImageSizeClass,
        _vm.isPersonField && _vm.hasAtLeastOneImage && "cog-checkable--avatars"
      ]
    },
    [
      _vm.readonly
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.displayValue,
                  expression: "displayValue"
                }
              ],
              staticClass: "cog-checkable__item is-read-only",
              class: {
                "cog-checkable__item--no-label":
                  _vm.hideChoiceLabels &&
                  _vm.selectedValue &&
                  _vm.hasImage(_vm.selectedValue)
              }
            },
            [
              _c(
                "div",
                { staticClass: "cog-choice-option" },
                [
                  _vm.selectedValue && _vm.hasImage(_vm.selectedValue)
                    ? _c(
                        "CChoiceImage",
                        _vm._b(
                          {
                            attrs: { option: _vm.selectedValue },
                            on: { dimensions: _vm.processDimensions }
                          },
                          "CChoiceImage",
                          {
                            isPersonField: _vm.isPersonField,
                            choiceImageSize: _vm.choiceImageSize,
                            fontSize: _vm.fontSize
                          },
                          false
                        )
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hideChoiceLabels || !_vm.hasImage(_vm.selectedValue)
                    ? _c("div", { staticClass: "cog-choice__readonly-label" }, [
                        _c("span", { staticClass: "cog-choice__value" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("spaceIfEmpty")(
                                _vm._f("breakWords")(
                                  _vm.selectedValue && _vm.selectedValue.label
                                    ? _vm.selectedValue.label
                                    : _vm.displayValue
                                )
                              )
                            )
                          )
                        ]),
                        _vm.isCard && _vm.selectedValue.description
                          ? _c(
                              "span",
                              { staticClass: "cog-choice__description" },
                              [_vm._v(_vm._s(_vm.selectedValue.description))]
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              )
            ]
          )
        : _c(
            "el-radio-group",
            {
              attrs: { role: null, label: null },
              on: { change: _vm.handleChange },
              model: {
                value: _vm.internalValue,
                callback: function($$v) {
                  _vm.internalValue = $$v
                },
                expression: "internalValue"
              }
            },
            [
              _vm._l(_vm.options, function(option, i) {
                return _c(
                  "el-radio",
                  {
                    key: option.value,
                    staticClass: "cog-checkable__item cog-choice-option",
                    class: [
                      { "cog-inner-col__item": _vm.hasColumns },
                      {
                        "cog-checkable__item--no-label":
                          _vm.hideChoiceLabels && _vm.hasImage(option)
                      }
                    ],
                    style: `order: ${_vm.optionOrder[i]}`,
                    attrs: { label: option.value, value: option.value },
                    nativeOn: {
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar"
                          ])
                        )
                          return null
                        return _vm.handleRadioSpace.apply(null, arguments)
                      },
                      click: function($event) {
                        return _vm.$emit("focus-lost")
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        !_vm.isCard && _vm.hasImage(option)
                          ? {
                              key: "image",
                              fn: function() {
                                return [
                                  _c(
                                    "CChoiceImage",
                                    _vm._b(
                                      {},
                                      "CChoiceImage",
                                      {
                                        option,
                                        isPersonField: _vm.isPersonField,
                                        choiceImageSize: _vm.choiceImageSize,
                                        fontSize: _vm.fontSize
                                      },
                                      false
                                    )
                                  )
                                ]
                              },
                              proxy: true
                            }
                          : null
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm.isCard
                      ? [
                          _c("ICardCheck", {
                            staticClass: "cog-choice__card-checkmark"
                          }),
                          _vm._v(" "),
                          _vm.hasImage(option)
                            ? _c(
                                "CChoiceImage",
                                _vm._b(
                                  { on: { dimensions: _vm.processDimensions } },
                                  "CChoiceImage",
                                  {
                                    option,
                                    isPersonField: _vm.isPersonField,
                                    choiceImageSize: _vm.choiceImageSize,
                                    fontSize: _vm.fontSize
                                  },
                                  false
                                )
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !(_vm.hideChoiceLabels && _vm.hasImage(option))
                            ? _c("div", [
                                _c(
                                  "span",
                                  { staticClass: "cog-choice__value" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("breakWords")(
                                          option.label
                                            ? option.label
                                            : option.displayValue
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                option.description
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "cog-choice__description"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.cleanChoiceDescription(
                                              option.description
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._v(" "),
                    !_vm.isCard &&
                    !(_vm.hideChoiceLabels && _vm.hasImage(option))
                      ? [
                          _c("span", { staticClass: "cog-choice__value" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("breakWords")(
                                  option.label
                                    ? option.label
                                    : option.displayValue
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          option.description
                            ? _c(
                                "span",
                                { staticClass: "cog-choice__description" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.cleanChoiceDescription(
                                        option.description
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm.allowOther
                ? _c(
                    "el-radio",
                    {
                      ref: "otherRadio",
                      staticClass:
                        "cog-checkable__item cog-choice-option cog-checkable__allow-other",
                      class: _vm.hasColumns ? "cog-inner-col__item" : null,
                      style: `order: ${_vm.optionOrder[_vm.options.length]}`,
                      attrs: { label: _vm.otherValue },
                      on: { change: _vm.handleOtherRadioChange },
                      nativeOn: {
                        click: function($event) {
                          return _vm.handleOtherRadioClick.apply(
                            null,
                            arguments
                          )
                        }
                      }
                    },
                    [
                      _c("el-input", {
                        ref: "otherInput",
                        attrs: {
                          tabindex: _vm.otherIsSelected ? "0" : "-1",
                          placeholder: _vm.$resource(
                            "field-choice-other-fill-in"
                          ),
                          label: _vm.$resource("field-choice-other-fill-in")
                        },
                        on: {
                          focus: _vm.handleOtherFocus,
                          blur: _vm.handleOtherBlur,
                          input: _vm.handleOtherInput
                        },
                        model: {
                          value: _vm.otherValue,
                          callback: function($$v) {
                            _vm.otherValue = $$v
                          },
                          expression: "otherValue"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }